export default {"src":"/_next/static/media/benefit_returns.c61e3f2c.svg","height":400,"width":400};